import { render, staticRenderFns } from "./HistogramSelector.vue?vue&type=template&id=241efe41&"
import script from "./HistogramSelector.vue?vue&type=script&lang=js&"
export * from "./HistogramSelector.vue?vue&type=script&lang=js&"
import style0 from "./HistogramSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports